// frontend/src/tabs/useTabParams.js
//
// The tabbed-shell replacement for react-router's `useParams()`. Reads
// path params from the TAB's path, not the global URL.
//
// Why this exists: <TabsHost/> renders multiple route components in the
// same React tree (the active tab + N hidden, still-mounted tabs). All those
// components share one global router state. So `useParams()` inside a
// hidden tab — or inside any tab during the one-render-frame between an
// activeId change and TabsHost's URL push — returns the params of
// whichever URL is currently in the browser address bar, NOT the params
// of the tab the component instance belongs to.
//
// `useTabParams()` reads from TabParamsContext, which TabsHost populates
// per tab via matchPath() against routeRegistry. Stable for the lifetime
// of the tab (a tab's path doesn't change after open). No render-timing
// race possible.
//
// Outside the tabbed shell (e.g. unit tests rendering a page without
// <TabsHost/>), returns an empty object — pages can still destructure
// without crashing.

import { useContext } from 'react';
import { TabParamsContext } from './tabsContexts';

export function useTabParams() {
  return useContext(TabParamsContext) ?? {};
}
